import {
  getCompany,
  setCompany,
  getCompanyInfoFromServer,
} from "../authentication";

export const FEATURE_MAPA_CADASTRO = "MAPA-CADASTRO";

/**
 * @param {String} name
 * @returns {Promise<Boolean>}
 */
export async function hasFeature(name) {
  const company = await getCompany();
  const flags = company.featureFlags;
  return Array.isArray(flags) && flags.includes(name);
}

/**
 * Atualiza featureFlags no cache da empresa sem perder o restante do objeto (ex.: link).
 * Falha de rede não zera as flags anteriores.
 */
export async function syncFeatureFlags() {
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return;
  }

  try {
    const company = await getCompany();
    const service = company.nome || company.identificador;
    const companyInfo = await getCompanyInfoFromServer(service);
    const featureFlags = Array.isArray(companyInfo.featureFlags)
      ? companyInfo.featureFlags
      : [];

    await setCompany({
      ...company,
      featureFlags,
    });
  } catch (error) {
    console.error("Erro ao sincronizar feature flags:", error);
  }
}
